// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const ASK_FOR_REGISTRATION = 'ASK_FOR_REGISTRATION';
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const END_REGISTER = 'END_REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
